import React, { useEffect } from 'react';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./Cookies.css"
import { Link } from 'react-router-dom';
import slide4 from "./../../images/tri_cor.jpg";
import useNavigation from '../../utils/Navigation';
function Cookies() {
  const navigateToSection =useNavigation()
  
  const handleClick = (event) => {
    event.preventDefault(); 
    if (window.Optanon) {
      window.Optanon.ToggleInfoDisplay();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <div className='faq_banner'><p>COOKIES</p></div>
      <div className="faq1">
      <div className='container'>
			<div className='row'>
			<div className='faq'>
			 <div className="cookies">
   	<p className="">Indegene use cookies to enhance website functionality and analyze site usage. Only necessary cookies will be stored by
default, and by clicking “Allow All Cookies”, you agree to the storage of all cookies on your device. You may personalize your
preferences, obtain more information, and withdraw or change your consent at any time by clicking on “Cookie Preferences”
or by visiting Indegene’s Cookie Notice link available on the website. For more information about the use of cookies, please
see the cookie notice web page.</p>
<h6>NECESSARY COOKIES</h6>
<p>Necessary cookies make a website usable by enabling basic functions such as page navigation and access to secure areas of
the website. These cookies cannot be switched off in Indegene's systems. They are usually only set in response to actions
made by you, which amount to a request for services, such as setting your privacy preferences, logging in or completing
forms. You may be able to decline these cookies through your browser, but necessary parts of the website will then not work.
These cookies do not store any personally identifiable information.</p>
<div className="table-responsive">
 <table className="table table-bordered">
    <thead className="table-dark">
      <tr>
        <th>COOKIE</th>
        <th>EXPIRY</th>
        <th>DOMAIN</th>
		 <th>COMPANY</th>
        <th>PURPOSE</th>
      </tr>
    </thead>
    <tbody>
      <tr className="custom_padd">
        <td>pll_language</td>
        <td>1 year</td>
        <td><Link to="#" target="_blank">https://demo.study.science/</Link> </td>
		 <td>Polylang</td>
        <td>Necessary</td>
      </tr>

    </tbody>
  </table>
  </div>
  <p>Polyang uses a cookie: This cookie is used to determine the preferred language of the visitor and set the language accordingly on the website if or when they visit again.</p>
<h6>COOKIE POLICY</h6>
<p>Cookies are small text files that are placed in the memory of your browser or device when you visit a website and allow that
website to recognize your browser or device. Each cookie is unique to your web browser and contains some anonymous
information, typically the name of the domain the cookie has come from, the “lifetime” of the cookie and a value (usually in
the form of a randomly generated unique number).
<br/><br/>
There are a number of different cookies:</p>
<div className="table-responsive">
 <table className="table table-bordered ">
    <thead className="table-dark">
      <tr>
        <th>COOKIE</th>
        <th className='text-start'>EXPIRY</th>
        
      </tr>
    </thead>
    <tbody>
      <tr>
        <td className="align-middle">Session cookies</td>
        <td className="text-start class">Temporary cookies that remain in the cookie file of your web browser for the duration of your visit
only and are deleted when you close the browser.</td>       
      </tr>
		<tr>
        <td className="align-middle">Persistent cookies</td>
        <td className="text-start class">Remain in the cookie file of your web browser even after the browser has been closed, sometimes
for a year or more, although the exact length of time will depend on the lifetime of the cookie.<br/><br/>
Persistent cookies are used when the website operator needs to know who you are for more than
one browsing session (for example, to remember your username or website customization
preferences).</td>       
      </tr>
	  <tr>
        <td className="align-middle">First-party cookies</td>
        <td className="text-start">Cookies planted in your browser and/or hard drive by the actual website you are visiting. First-party cookies assign you a unique identity so they can track your journey through the
website.<br/><br/>
Website operators often use first-party cookies for session management and recognition
purposes.</td>       
      </tr>
	  <tr>
        <td className="align-middle">Third-party cookies</td>
        <td className="text-start class">Cookies used by third parties, such as social networks, to track visits to websites on which they
advertise. The website operator does not have control over these third-party cookies.</td>       
      </tr>
    </tbody>
  </table>
  </div>
  <p>On this website, Indegene use the cookies described in the table below in order to improve the user experience for website visitors:</p>
<div className="table-responsive">
<table className="table table-bordered table-fit">
    <thead className="table-dark ">
      <tr>
        <th scope="col">COOKIE</th>
        <th scope="col">DESCRIPTION</th>
        <th scope="col">DURATION</th>
        <th scope="col">TYPE</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td className="align-middle">pll_language</td>
        <td  className="text-start align-middle">Polyang uses a cookie: This
cookie is used to determine the
preferred language of the
visitor and set the language
accordingly on the website if or
when they visit again.</td>
        <td className="align-middle"> 1 year</td>
        <td className="align-middle">Necessary</td>
      </tr>

    </tbody>
  </table>
  </div>
  <p>When you first visit this <Link to="https://demo.study.science/" target="_blank">https://demo.study.science/</Link> website, a cookie control box is displayed, which allows you to choose whether
to allow cookies or not. Only necessary cookies will be set when you first visit our site.
</p>
  <p>You have the right to withdraw your consent to the use of these cookies at any time. If you remove or decline the use of
cookies on this website, the website functionality should not be significantly impacted. However, this may result in
difficulties navigating around the website, and some features of the website may become unavailable. In addition, disabling a cookie or category of cookie will not delete an existing cookie from your browser; this will need to be done separately from within your own browser. Please refer to your internet browser’s “Help” facility for further information.
</p>
  <p className='clckHereP'><i>To change your cookie preference settings please <Link to="#" target="_blank" id="onetrustcookie" onClick={handleClick}>click here</Link></i></p></div><img src={slide4} alt="border" className='bor'/></div></div></div></div>
  <Link to = "/#eligibility"  onClick={() => navigateToSection('eligibility')} alt="sticky button"><button className="sticky_eligibility">See if you qualify</button></Link>
      <Footer />
    </>
  );
}

export default Cookies;